import { connect } from 'react-redux';
import RommFormWrapper from "../components/general/RommFormWrapper";
import { ADD_ROOM, UPDATE_ROOM } from "../store/actions/room";

const mapStateToProps = state => {
    return {
        
    };
};

const mapDispatchToProps = dispatch => {
    return {
        ADD_ROOM: body => dispatch(ADD_ROOM(body)),   
        UPDATE_ROOM: body => dispatch(UPDATE_ROOM(body)),  
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RommFormWrapper);


// WEBPACK FOOTER //
// ./src/containers/RoomsForm.js